var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoccerField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1582,
    height: 761,
    viewBox: "0 0 1582 761",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M139.951 760.143H0L234.443 0H335.193L139.951 760.143Z",
    fill: "url(#paint0_linear_22201_32060)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.726 760.143H279.902L436.07 0H536.947L419.726 760.143Z",
    fill: "url(#paint1_linear_22201_32060)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.628 760.143H559.677L637.825 0H738.574L699.628 760.143Z",
    fill: "url(#paint2_linear_22201_32060)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.399 760.143H839.448V0H940.325L979.399 760.143Z",
    fill: "url(#paint3_linear_22201_32060)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.18 760.143H1119.35L1041.21 0H1142.08L1259.18 760.143Z",
    fill: "url(#paint4_linear_22201_32060)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.08 760.143H1399.13L1242.83 0H1343.71L1539.08 760.143Z",
    fill: "url(#paint5_linear_22201_32060)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.242 589.081H130.607L131.758 584.949L264.091 101.563H496.92L416.242 589.081ZM139.046 582.624H410.744L489.377 108.279H268.95L139.046 582.624Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.303 433.639H172.129L173.278 429.557L233.166 213.503H321.529L269.303 433.639ZM180.94 427.261H264.195L313.867 219.752H238.401L180.94 427.261Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.669 365.787H156.68L183.878 272.682H223.207L197.669 365.787ZM164.98 359.41H192.817L215.035 279.059H188.603L164.98 359.41Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M847.876 318.851C847.367 320.675 846.273 322.283 844.763 323.428C843.253 324.573 841.409 325.193 839.512 325.193C837.616 325.193 835.772 324.573 834.262 323.428C832.751 322.283 831.658 320.675 831.148 318.851C831.434 316.92 832.459 315.176 834.008 313.986C835.556 312.797 837.507 312.254 839.448 312.474C844.045 312.091 847.876 314.897 847.876 318.851Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.843 318.852C383.097 320.796 381.759 322.456 380.018 323.6C378.277 324.744 376.221 325.314 374.139 325.23C369.542 325.23 366.349 322.296 367.116 318.852C367.804 316.896 369.111 315.217 370.838 314.067C372.565 312.916 374.62 312.358 376.693 312.475C381.289 312.093 384.482 314.899 383.843 318.852Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M839.451 433.639C818.056 434.291 796.75 430.604 776.822 422.8C756.893 414.996 738.756 403.237 723.506 388.234C714.486 379.137 707.439 368.282 702.803 356.345C698.168 344.408 696.044 331.645 696.563 318.852C700.138 260.183 762.963 214.269 839.451 214.269C915.939 214.269 978.763 260.183 982.466 318.852C983.021 331.687 980.915 344.499 976.278 356.482C971.642 368.465 964.576 379.363 955.523 388.489C940.228 403.45 922.059 415.163 902.111 422.923C882.162 430.682 860.848 434.328 839.451 433.639V433.639ZM839.451 220.391C766.283 220.391 706.395 263.627 702.948 318.98C702.434 330.981 704.441 342.957 708.84 354.138C713.238 365.318 719.93 375.456 728.486 383.898C758.843 411.791 798.586 427.272 839.834 427.272C881.082 427.272 920.825 411.791 951.182 383.898C959.744 375.439 966.43 365.278 970.808 354.072C975.186 342.867 977.156 330.867 976.593 318.852C972.634 263.244 912.746 220.008 839.451 220.008V220.391Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M438.24 413.614L468.886 230.465L472.845 232.761C488.305 240.761 500.939 253.303 509.044 268.696C517.15 284.089 520.336 301.593 518.176 318.851C513.196 354.562 485.359 388.871 443.859 410.553L438.24 413.614ZM473.611 240.796L446.668 401.752C483.188 380.963 507.322 349.971 511.919 317.958C514.025 302.742 511.497 287.245 504.665 273.483C497.833 259.721 487.012 248.331 473.611 240.796V240.796Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M842.643 704.408H97.5576L98.7069 700.327L284.755 28.6963H842.643V704.408ZM105.985 698.031H836.131V34.8183H289.607L105.985 698.031Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282.202 52.9291H277.988L284.756 28.6963H317.956L316.934 32.6501C313.893 39.1545 308.941 44.5793 302.736 48.2021C296.531 51.8249 289.369 53.4737 282.202 52.9291V52.9291ZM289.608 35.0733L287.054 46.2969C295.732 45.6545 303.807 41.6219 309.528 35.0733H289.608Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.824 704.407H97.5576L108.028 666.145H110.455C115.292 665.997 120.101 666.941 124.522 668.906C128.944 670.871 132.865 673.808 135.993 677.496C138.585 680.854 140.342 684.779 141.119 688.947C141.896 693.116 141.671 697.409 140.462 701.474L139.824 704.407ZM105.985 698.03H134.844C135.404 695.243 135.364 692.368 134.725 689.597C134.087 686.826 132.865 684.223 131.141 681.96C128.896 679.284 126.107 677.115 122.959 675.597C119.81 674.08 116.375 673.249 112.881 673.16L105.985 698.03Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.89 583.499H1262.75V580.821L1182.18 102.032H1414.71L1547.89 583.499ZM1268.11 577.122H1539.59L1409.85 108.664H1189.71L1268.11 577.122Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1506.39 433.639H1409.73L1356.99 213.503H1445.48L1506.39 433.639ZM1414.83 427.261H1498.09L1440.63 219.88H1365.16L1414.83 427.261Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1522.35 365.787H1480.98L1455.44 272.682H1495.28L1522.35 365.787ZM1485.96 359.41H1513.79L1490.43 279.059H1463.61L1485.96 359.41Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.82 318.852C1296.54 320.819 1297.87 322.502 1299.62 323.651C1301.36 324.801 1303.44 325.354 1305.53 325.229C1310.13 325.229 1313.32 322.296 1312.55 318.852C1311.84 316.886 1310.51 315.203 1308.76 314.053C1307.01 312.904 1304.94 312.35 1302.85 312.475C1297.61 312.093 1294.42 314.899 1295.82 318.852Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.79 413.614L1235.04 410.553C1193.67 388.871 1165.83 354.562 1160.73 318.851C1158.64 301.556 1161.9 284.036 1170.07 268.646C1178.24 253.256 1190.93 240.733 1206.44 232.761L1210.53 230.465L1240.79 413.614ZM1205.29 240.796C1191.95 248.397 1181.18 259.797 1174.35 273.542C1167.53 287.286 1164.96 302.75 1166.98 317.958C1171.45 349.971 1195.71 380.963 1232.23 401.752L1205.29 240.796Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1581.47 704.408H836.13V28.4414H1394.15L1581.47 704.408ZM842.642 698.031H1573.04L1389.42 34.8185H842.642V698.031Z",
    fill: "url(#paint6_linear_22201_32060)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.04 52.9291H1396.83C1389.66 53.492 1382.49 51.8509 1376.28 48.226C1370.07 44.601 1365.12 39.1659 1362.1 32.6501L1361.07 28.6963H1394.27L1401.04 52.9291ZM1370.14 35.0733C1372.97 38.3269 1376.4 40.9928 1380.26 42.9186C1384.12 44.8444 1388.31 45.9923 1392.61 46.2969L1389.42 35.0733H1370.14Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1581.47 704.408H1539.08L1538.44 701.475C1537.25 697.415 1537.03 693.136 1537.78 688.975C1538.54 684.814 1540.25 680.885 1542.78 677.497C1545.9 673.794 1549.82 670.848 1554.24 668.881C1558.67 666.915 1563.48 665.979 1568.32 666.146H1570.75L1581.47 704.408ZM1544.19 698.031H1573.04L1566.15 673.161C1562.64 673.287 1559.2 674.134 1556.04 675.648C1552.87 677.163 1550.06 679.311 1547.76 681.961C1546.08 684.245 1544.89 686.853 1544.28 689.62C1543.66 692.387 1543.63 695.251 1544.19 698.031Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22201_32060",
    x1: 15251.3,
    y1: 192255,
    x2: 15251.3,
    y2: 146951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22201_32060",
    x1: 11975.5,
    y1: 192255,
    x2: 11975.5,
    y2: 146951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22201_32060",
    x1: 12073.5,
    y1: 192255,
    x2: 12073.5,
    y2: 146951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22201_32060",
    x1: 12698.9,
    y1: 192255,
    x2: 12698.9,
    y2: 146951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22201_32060",
    x1: 23623,
    y1: 192255,
    x2: 23623,
    y2: 146951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22201_32060",
    x1: 37518.2,
    y1: 192255,
    x2: 37518.2,
    y2: 146951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAECAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22201_32060",
    x1: 849.458,
    y1: 714.02,
    x2: 1139.53,
    y2: 28.0355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerField);
export default __webpack_public_path__ + "static/media/soccer-field.8c9a60d852f5f3094711940d28a0b82d.svg";
export { ForwardRef as ReactComponent };